import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'

export const wrapper = {
  ...sharedStyles.row,
  paddingBottom: 16,
}
